export default __webpack_public_path__ + "static/media/blog01.cefc0932.png";